import BaseApi from "./baseApi";

class retreatBackUpApi extends BaseApi {
    
  async getBackUpRetreats(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreat-backup/getBackUpRetreats",
      data: data,
      method: "post",
    });
  }

    async permanentDeleteRetreat(data: Record<string, unknown> | object): Promise<any> {
      return this.API({
        url: "/retreat-backup/permanentDeleteRetreat",
        data: data,
        method: "post",
      });
    }


    async restoreRetreat(data: Record<string, unknown> | object): Promise<any> {
      return this.API({
        url: "/retreat-backup/restoreRetreat",
        data: data,
        method: "post",
      });
    }
}

export default retreatBackUpApi;
